import React from 'react';
import './userTutorialCards.module.scss';
import { AllUserTutorialCompletionKeys } from '../../../types/userTutorialCompletions';
import { UserTutorialCard } from '../../molecules/user_tutorial/UserTutorialCard';
import ImageShechanCelebrate from './images/she_chan_celebrate.svg';
import Slider from 'react-slick';
import { BodyText, Heading } from '@sheinc/shelikes-design-system';

export const UserTutorialCards = () => {
  return (
    <div styleName="user-tutorial-pane" id="user-tutorial-cards">
      <div styleName="user-tutorial-header">
        <div styleName="user-tutorial-header-title">
          <Heading size="M">まずはこちらに取り組んでみよう！</Heading>
        </div>
        <BodyText>
          受講を始めるみなさんは、まずは以下の5つに取り組みましょう！
          <br />
          取り組むことで、スムーズに受講をはじめることができます✨
          <br />
          (取り組む順番に決まりはありませんので出来るものから進めてください)
        </BodyText>
      </div>
      <div styleName="user-tutorial-cards">
        {AllUserTutorialCompletionKeys.map((page_key, idx) => {
          return <UserTutorialCard key={idx} page_key={page_key} />;
        })}
      </div>
      <img styleName="she_chan_celebrate" src={ImageShechanCelebrate} />
    </div>
  );
};

export const UserTutorialCardSp = () => {
  const settings = {
    className: 'slider variable-width',
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    variableWidth: true,
    touchThreshold: 1000,
  };
  return (
    <div styleName="user-tutorial-pane" id="user-tutorial-cards">
      <div styleName="user-tutorial-header">
        <div styleName="user-tutorial-header-title">
          <Heading size="M">まずはこちらに取り組んでみよう！</Heading>
        </div>
        <BodyText>
          受講を始めるみなさんは、まずは以下の5つに取り組みましょう！
          取り組むことで、スムーズに受講をはじめることができます✨
          <br />
          (取り組む順番に決まりはありませんので出来るものから進めてください)
        </BodyText>
      </div>
      <div styleName="user-tutorial-cards">
        <Slider {...settings}>
          {AllUserTutorialCompletionKeys.map((page_key, idx) => (
            <UserTutorialCard key={idx} page_key={page_key} />
          ))}
        </Slider>
      </div>
    </div>
  );
};
